import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * Servicio utilizado por los componentes padres para activar spinner
 */
import { SpinnerAlertService } from '../../../services/spinner-alert.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})

/**
 * Componente que presenta un icóno de cargando para indicar que una operación se está realizando
 * - El componente se subscribe a un servicio para atender aviso y ser lanzado
 * - Al finalizar el componente de quita la subscripción
 *
 * @author: Isaac Salgado @iiSalgado
 * @version: 11/09/2018
 */
export class SpinnerComponent implements OnInit, OnDestroy {

  /**
   * Bandera para ocultar / mostrar Spinner
   */
  show: boolean;

  /**
   * Elemento para subscripción al servicio
   */
  private _subscriptionAlert: Subscription;

  /**
   * - Referencias al servicio de mensajes
   * - Subscripción a servicio de mensajes
   * @param spinnerAlertService SpinnerAlertService
   */
  constructor(
    private spinnerAlertService: SpinnerAlertService
  ) {
    this._subscriptionAlert = this.spinnerAlertService.showAlert().subscribe((showAlert: boolean) => {
      this.show = showAlert;
    });
  }
/*Inicializa componente */
  ngOnInit() {
  }

  /**
   * Elimina subscripción a servicio de mensajes
   */
  ngOnDestroy(): void {
    this._subscriptionAlert.unsubscribe();
  }
}
